__webpack_require__.p = "https://static.practice.do/_next/";